// extracted by mini-css-extract-plugin
export default {"content":"FollowUs_content__bSR4E","links":"FollowUs_links__zolvK","link":"FollowUs_link__zogFA"};